var cov_2jctpzjud0 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/InputTitle/inputTitle.tsx",
      hash = "0442a3f69a23485b65cbaf296bda7d22c6d06c42",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/InputTitle/inputTitle.tsx",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 16
        }
      },
      "1": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 16,
          column: 5
        }
      },
      "2": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 54
        }
      },
      "3": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 23,
          column: 5
        }
      },
      "4": {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 22,
          column: 27
        }
      },
      "5": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 29,
          column: 6
        }
      },
      "6": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 35,
          column: 6
        }
      },
      "7": {
        start: {
          line: 39,
          column: 99
        },
        end: {
          line: 39,
          column: 109
        }
      },
      "8": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 36
        }
      },
      "9": {
        start: {
          line: 40,
          column: 21
        },
        end: {
          line: 40,
          column: 36
        }
      },
      "10": {
        start: {
          line: 41,
          column: 26
        },
        end: {
          line: 41,
          column: 36
        }
      },
      "11": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 55,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        loc: {
          start: {
            line: 12,
            column: 38
          },
          end: {
            line: 18,
            column: 3
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        },
        loc: {
          start: {
            line: 20,
            column: 49
          },
          end: {
            line: 24,
            column: 3
          }
        },
        line: 20
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 3
          }
        },
        loc: {
          start: {
            line: 26,
            column: 19
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 26
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        },
        loc: {
          start: {
            line: 32,
            column: 18
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 32
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        loc: {
          start: {
            line: 38,
            column: 11
          },
          end: {
            line: 56,
            column: 3
          }
        },
        line: 38
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        }, {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        }],
        line: 21
      },
      "1": {
        loc: {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 40,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 40,
            column: 36
          }
        }, {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 40,
            column: 36
          }
        }],
        line: 40
      },
      "2": {
        loc: {
          start: {
            line: 45,
            column: 51
          },
          end: {
            line: 45,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 45,
            column: 51
          },
          end: {
            line: 45,
            column: 55
          }
        }, {
          start: {
            line: 45,
            column: 59
          },
          end: {
            line: 45,
            column: 65
          }
        }],
        line: 45
      },
      "3": {
        loc: {
          start: {
            line: 45,
            column: 67
          },
          end: {
            line: 45,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 45,
            column: 67
          },
          end: {
            line: 45,
            column: 76
          }
        }, {
          start: {
            line: 45,
            column: 80
          },
          end: {
            line: 45,
            column: 91
          }
        }],
        line: 45
      },
      "4": {
        loc: {
          start: {
            line: 52,
            column: 65
          },
          end: {
            line: 52,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 52,
            column: 65
          },
          end: {
            line: 52,
            column: 75
          }
        }, {
          start: {
            line: 52,
            column: 79
          },
          end: {
            line: 52,
            column: 89
          }
        }],
        line: 52
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/InputTitle/inputTitle.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import { inputTitleClass } from './styles';

var InputTitle =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(InputTitle, _PureComponent);

  var _super = _createSuper2(InputTitle);

  function InputTitle(props) {
    var _this;

    _classCallCheck(this, InputTitle);

    cov_2jctpzjud0.f[0]++;
    cov_2jctpzjud0.s[0]++;
    _this = _super.call(this, props);
    cov_2jctpzjud0.s[1]++;
    _this.state = {
      animation: false
    };
    cov_2jctpzjud0.s[2]++;
    _this.stopAnimation = _this.stopAnimation.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InputTitle, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_2jctpzjud0.f[1]++;
      cov_2jctpzjud0.s[3]++;

      if (prevProps.open !== this.props.open) {
        cov_2jctpzjud0.b[0][0]++;
        cov_2jctpzjud0.s[4]++;
        this.startAnimation();
      } else {
        cov_2jctpzjud0.b[0][1]++;
      }
    }
  }, {
    key: "startAnimation",
    value: function startAnimation() {
      cov_2jctpzjud0.f[2]++;
      cov_2jctpzjud0.s[5]++;
      this.setState({
        animation: true
      });
    }
  }, {
    key: "stopAnimation",
    value: function stopAnimation() {
      cov_2jctpzjud0.f[3]++;
      cov_2jctpzjud0.s[6]++;
      this.setState({
        animation: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      cov_2jctpzjud0.f[4]++;

      var _ref = (cov_2jctpzjud0.s[7]++, this.props),
          innerTitle = _ref.innerTitle,
          className = _ref.className,
          style = _ref.style,
          children = _ref.children,
          open = _ref.open,
          titleClass = _ref.titleClass,
          contentClass = _ref.contentClass,
          placeTitle = _ref.placeTitle;

      cov_2jctpzjud0.s[8]++;

      if (!innerTitle) {
        cov_2jctpzjud0.b[1][0]++;
        cov_2jctpzjud0.s[9]++;
        return children;
      } else {
        cov_2jctpzjud0.b[1][1]++;
      }

      var _ref2 = (cov_2jctpzjud0.s[10]++, this.state),
          animation = _ref2.animation;

      cov_2jctpzjud0.s[11]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: style,
          className: classnames(inputTitleClass('_', (cov_2jctpzjud0.b[2][0]++, open) && (cov_2jctpzjud0.b[2][1]++, 'open'), (cov_2jctpzjud0.b[3][0]++, animation) && (cov_2jctpzjud0.b[3][1]++, 'animation')), className),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 43,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          onAnimationEnd: this.stopAnimation,
          className: classnames(inputTitleClass('title', 'top'), titleClass),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 47,
            columnNumber: 9
          }
        }, innerTitle),
        /*#__PURE__*/
        React.createElement("div", {
          className: classnames(contentClass, inputTitleClass('content')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 50,
            columnNumber: 9
          }
        }, children),
        /*#__PURE__*/
        React.createElement("div", {
          onAnimationEnd: this.stopAnimation,
          className: inputTitleClass('place'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 51,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: classnames(inputTitleClass('title')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 52,
            columnNumber: 11
          }
        }, (cov_2jctpzjud0.b[4][0]++, placeTitle) || (cov_2jctpzjud0.b[4][1]++, innerTitle))))
      );
    }
  }]);

  return InputTitle;
}(PureComponent);

export default InputTitle;